import { createSelector } from '@reduxjs/toolkit';
import { getSalesSpaceListState } from './getSalesSpaceListState';

export const getSelectedSalesSpaceChannelFilter = createSelector(
  getSalesSpaceListState,
  (channelList) => channelList.selectedSalesSpaceChannelFilter,
);
